import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';

/**
 * Parent component for the Implication and Next Steps dialog.
 * This component is used to display the dialog for editing the implications and next steps for a service insight.
 * TODO: Component uses Angular Material v16 which has been deprecated.
 * Consider updating to the latest version OR moving away from the library to gain more control over the UI and reduce dependency on external libraries.
 */
@Component({
    selector: 'implication-dialog',
    templateUrl: './implication-dialog.component.html',
    styleUrls: ['./implication-dialog.component.scss'],
    standalone: false
})
export class ImplicationDialogComponent {
  //binding to respective form inputs
  editForm = new UntypedFormGroup({
    implication1: new UntypedFormControl(this.data.items[0] ?? ''),
    implication2: new UntypedFormControl(this.data.items[1] ?? ''),
    implication3: new UntypedFormControl(this.data.items[2] ?? ''),
  });

  implicationControls = ['implication1', 'implication2', 'implication3'];
  implicationType: string = '';
  key: string = ''; // Formatted implicationType for HTML element IDs and classes (e.g., "next-steps" or "implications")
  initialOrder: string[] = [
    this.data.items[0],
    this.data.items[1],
    this.data.items[2],
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImplicationDialogComponent>,
    private _mixpanelService: MixpanelService,
  ) {
    if (this.data.isNextSteps) {
      this.implicationType = 'Next Steps';
      this.key = 'next-steps';
    } else {
      this.implicationType = 'Implications';
      this.key = 'implications';
    }
  }

  onSubmit() {
    let i = 0;

    Object.entries(this.editForm.value).forEach(([key, value]) => {
      if (
        value != undefined &&
        value != '' &&
        value != null &&
        value != 'custom'
      ) {
        this.data.items[i] = value;
        this.initialOrder[i] = this.data.items[i];
        this._mixpanelService.track(
          `Service Insights ${this.implicationType} Added`,
          {
            Tab: this.data.tab,
            Findings: this.data.findings,
            'Implication Type': this.implicationType,
            Value: value,
          },
        );
        ++i;
      } else {
        this.data.items.splice(i, 1);
      }
    });

    this.dialogRef.close();
  }

  resetValues() {
    this.editForm.patchValue({
      implication1: this.initialOrder[0] ?? '',
      implication2: this.initialOrder[1] ?? '',
      implication3: this.initialOrder[2] ?? '',
    });
    this._mixpanelService.track(
      `Service Insights ${this.implicationType} Reset`,
    );
  }

  updateValues() {
    this.editForm.patchValue({
      implication1: this.data.items[0] ?? '',
      implication2: this.data.items[1] ?? '',
      implication3: this.data.items[2] ?? '',
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    let i = 0;
    Object.entries(this.editForm.value).forEach(([key, value]) => {
      if (
        value != undefined &&
        value != '' &&
        value != null &&
        value != 'custom'
      ) {
        this.data.items[i] = value;
        ++i;
      } else {
        this.data.items.splice(i, 1);
      }
    });
    moveItemInArray(this.data.items, event.previousIndex, event.currentIndex);
    this.updateValues();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
